<template>
  <button
      class="btn"
      :disabled="disabled"
      :type="type"
      :class="[ themes[theme], sizes[size], { 'btn--beauty': disabled }, { 'btn--preload': preload } ]"
  >
    <slot v-if="!preload" />
    <img v-if="preload" src="@/assets/img/preloader.svg" alt="" class="btn__preloader" />
  </button>
</template>

<script>
export default {
  name: 'AppButton',
  data() {
    return {
      themes: {
        default: 'btn--default',
        request: 'btn--request',
        dark: 'btn--dark',
        error: 'btn--error',
        tooltip: 'btn--tooltip',
        warn: 'btn--warn',
        export: 'btn--export',
        empty: 'btn--empty',
        info: 'btn--blue',
        outcome: 'btn--outcome',
      },
      sizes: {
        normal: '',
        small: 'btn--small'
      },
      preload: false,
    }
  },
  props: {
    theme: {
      type: String,
      default: 'default'
    },
    size: {
      type: String,
      default: 'normal'
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    type: {
      type: String,
      default: 'button'
    },
  },
}
</script>

<style lang="sass">
.btn
  position: relative
  display: flex
  align-items: center
  justify-content: center
  gap: 10px
  min-width: 130px
  min-height: 38px
  padding: 12px 14px 11px
  border-radius: 8px
  color: #fff
  font-size: 15px
  font-weight: 500
  line-height: 1
  text-align: center
  text-decoration: none
  transition: background-color 0.3s
  cursor: pointer
  user-select: none

.btn--preload
  pointer-events: none

.btn--default
  background-color: $color-theme

  &:hover, &:focus
    background-color: #72a915

.btn--request
  background-color: #77b017

  &:hover, &:focus
    background-color: #6da414

.btn--dark
  background-color: #939393

  &:hover
    background-color: #434343

.btn--error
  background-color: #dd4e4e

  &:hover
    background-color: #d23535

.btn--blue
  background-color: #35a4ea

  &:hover
    background-color: #439ad1

.btn--warn
  background-color: #f0c427

  &:hover
    background-color: #ebc027

.btn--outcome
  background-color: #e85c20

  &:hover
    background-color: #e54a07

.btn--stretch
  width: 100%

.btn--center
  margin: 0 auto

.btn--beauty
  background-color: #c4c4c4
  pointer-events: none

.btn--small
  min-width: auto
  min-height: 100%
  padding: 9px 13px 8px
  font-size: 13px
  font-weight: 500

  &.btn--preload
    min-width: 70px
    min-height: 30px

.btn--tooltip
  min-width: auto
  min-height: auto
  width: 15px
  height: 15px
  padding: 0
  border-radius: 0
  background-image: url("~@/assets/img/tooltip-icon.svg")
  background-repeat: no-repeat
  background-position: right center

.btn__preloader
  position: absolute
  top: 50%
  left: 50%
  width: 20px
  height: 20px
  transform: translate(-50%, -50%)

.btn--export
  flex-shrink: 0
  position: relative
  min-width: auto
  min-height: auto
  padding: 0
  border-radius: 0
  color: #679c0d
  font-size: 14px
  font-weight: 600
  transition: opacity 0.3s
  opacity: 0.9

  &:before
    content: ""
    position: absolute
    right: -25px
    display: none
    width: 20px
    height: 20px
    background-image: url("~@/assets/img/preloader-export.svg")
    background-size: cover

  &:hover
    opacity: 1

.btn--export--loading
  pointer-events: none

  &:before
    display: block

.btn--empty
  min-width: auto
  min-height: auto
  padding: 0
  border-radius: 0
</style>
